export const pembayaran = [
  {
    label: "Bank Mandiri",
    img:
      "https://cdn.siap.id/s3/masook/asset%20img/portal/pembayaran/682386_720.jpg",
    pembayarans: [
      {
        label: "Mandiri ATM",
        deskripsi: [
          "Pilih menu “ Bayar / Beli ”",
          "Pilih menu “ Telepon / Telko “",
          "Pilih menu “ CDMA / Telkom “",
          "Pilih menu “ Telkom / Internet “",
          "Masukkan “ 12 digit kode pembayaran “ (021xxxxxxxxx) yang diterima di kolom “ Kode Area + No. Telepon ”",
          "Pilih “ Ya “ untuk melanjutkan proses selanjutnya",
          "Muncul konfirmasi permintaan dan pastikan sudah benar",
          "Pilih “ Ya ” untuk melanjutkan pembayaran",
          "Transaksi selesai dan Anda menerima struk transaksi berhasil"
        ]
      },
      {
        label: "Mandiri Internet Banking",
        deskripsi: [
          "Login akun Mandiri Internet Banking",
          "Pilih jenis transaksi “ Bayar “",
          "Pilih menu “ Telepon “",
          "Pilih penyedia jasa “ Telkom “",
          "Masukkan “ 12 digit kode pembayaran “ (021xxxxxxxxx) yang diterima di kolom “ Kode Area + No. Telepon ”",
          "Pilih “ Lanjutkan “untuk melanjutkan ke proses konfirmasi permintaan",
          "Muncul konfirmasi permintaan dan pastikan sudah benar",
          "Masukkan “ PIN “ dan pilih “ Kirim “ untuk melanjutkan pembayaran",
          "Transaksi selesai dan Anda menerima notifikasi transaksi berhasil"
        ]
      },
      {
        label: "Mandiri Online (Mobile Apps)",
        deskripsi: [
          "Login akun Mandiri Online (Mobile Apps)",
          "Pilih menu “ Bayar “",
          "Pilih penyedia jasanya “ Telkom “",
          "Pilih bagian penyedia “ Telkom/Indihome “",
          "Masukkan “ 12 digit kode pembayaran (021xxxxxxxxx) “ yang didapat dalam proses berlangganan di Portal Masook dan pastikan sudah benar",
          "Pilih lanjutkan, dan akan muncul konfirmasi permintaan dan pastikan sudah benar",
          "Masukkan “ MPIN “ dan pilih “ Kirim “ untuk melanjutkan pembayaran",
          "Transaksi selesai dan Anda menerima resi transaksi berhasil"
        ]
      }
    ]
  },
  {
    label: "Bank Mandiri Syariah",
    img: "https://cdn.siap.id/s3/masook/asset%20img/portal/pembayaran/BSM-.jpg",
    deskripsi: [
      "Pilih menu “ Menu Utama ”",
      "Pilih menu “ Pembayaran ”",
      "Pilih menu “ Telkom Pay ”",
      "Pilih menu “ Telkom Pay ” kembali pada layar berikut",
      "Masukkan “ 12 digit kode pembayaran “ (021xxxxxxxxx) yang diterima di kolom “ Kode Area + No. Telepon ”",
      "Pilih “ Benar ” untuk melanjutkan permintaan",
      "Muncul konfirmasi permintaan pembayaran pada layar ATM",
      "Setelah konfirmasi benar, pilih “ Bayar ” untuk melanjutkan pembayaran",
      "Transaksi selesai dan Anda menerima struk transaksi berhasil"
    ]
  },
  {
    label: "Bank BNI",
    img:
      "https://cdn.siap.id/s3/masook/asset%20img/portal/pembayaran/polisi-periksa-12-saksi-kasus-pembobolan-bni.jpg",
    pembayarans: [
      {
        label: "ATM (dalam Bahasa Indonesia)",
        deskripsi: [
          "Pilih menu “ Menu Lain ”",
          "Pilih menu “ Pembayaran “",
          "Pilih jenis pembayaran “ Telepon / HP “",
          "Pilih jenis pembayaran “ Telkom Telepon “",
          "Masukkan “ 0 + 12 digit kode pembayaran “ (0021xxxxxxxxx) yang diterima di kolom “ Kode Area + No. Telepon ”",
          "Pilih “ Ya ” jika permintaan sudah benar dan melanjutkan proses selanjutnya (rekening sumber dana)",
          "Pilih “ rekening sumber dana “ Anda dan pastikan sudah benar",
          "Pilih “ Ya “ untuk melanjutkan pembayaran",
          "Transaksi selesai dan Anda menerima struk transaksi berhasil"
        ]
      },
      {
        label: "BNI Mobile",
        deskripsi: [
          "Login akun BNI Mobile",
          "Pilih menu “ Pembayaran “",
          "Pilih menu “ Pascabayar Telepon “",
          "Pilih jenis “ Pascabayar Telkom “",
          "Masukkan “ 12 digit kode pembayaran “ (021xxxxxxxxx) yang diterima di kolom “ Kode Area + No. Telepon ”",
          "Pilih “ Lanjut “untuk melanjutkan ke proses konfirmasi permintaan",
          "Masukkan “ PIN “ dan pilih “ Lanjut “ untuk melanjutkan pembayaran",
          "Transaksi selesai dan Anda menerima notifikasi transaksi berhasil",
          "Mohon tunggu beberapa saat dan saldo akun <i>e-money</i> Anda bertambah"
        ]
      }
    ]
  },
  {
    label: "Bank BCA",
    img:
      "https://cdn.siap.id/s3/masook/asset%20img/portal/pembayaran/logo-bank-bca.jpg",
    pembayarans: [
      {
        label: "ATM (dalam Bahasa Indonesia)",
        deskripsi: [
          "Pilih menu “ Transaksi Lainnya ”",
          "Pilih transaksi “ Pembayaran “",
          "Pilih jenis pembayaran “ Telepon / Handphone “",
          "Pilih penyedia operator telepon “ Telkom “",
          "Masukkan “ 12 digit kode pembayaran “ (021xxxxxxxxx) yang diterima di kolom “ Kode Area + No. Telepon ”",
          "Pilih “ Ya “ untuk melanjutkan proses selanjutnya",
          "Muncul konfirmasi permintaan dan pastikan sudah benar",
          "Pilih “ Ya ” untuk melanjutkan pembayaran",
          "Transaksi selesai dan Anda menerima struk transaksi berhasil"
        ]
      },
      {
        label: "Internet Banking (BCA Klik Play)",
        deskripsi: [
          "Login akun Klik BCA",
          "Pilih menu “ Pembayaran ”",
          "Pilih jenis pembayaran “ Telepon “",
          "Pilih penyedia operator telepon “ Telkom “",
          "Masukkan “ 12 digit kode pembayaran “ (021xxxxxxxxx) yang diterima di kolom “ Kode Area + No. Telepon ”",
          "Klik “ Lanjutkan “ untuk melanjutkan proses selanjutnya",
          "Muncul konfirmasi permintaan dan pastikan sudah benar",
          "Masukkan “ kode respon key BCA ” untuk melanjutkan pembayaran",
          "Klik “ Submit “ untuk menyelesaikan pembayaran",
          "Transaksi selesai dan Anda menerima notifikasi transaksi berhasil"
        ]
      },
      {
        label: "BCA Mobile (M-BCA)",
        deskripsi: [
          "Login akun M BCA (BCA Mobile)",
          "Pilih jenis “ m-BCA ”",
          "Masukkan “ Kode Akses “ yang telah terdaftar",
          "Pilih menu “ m-Payment “",
          "Pilih jenis pembayaran “ Telepon “",
          "Pilih penyedia operator telepon “ Telkom “",
          "Masukkan “ 12 digit kode pembayaran “ (021xxxxxxxxx) yang diterima di kolom “ Kode Area + No. Telepon ”",
          "Pilih “ Send “ untuk melanjutkan proses selanjutnya",
          "Muncul konfirmasi permintaan dan pastikan sudah benar",
          "Pilih “ OK “ untuk melanjutkan proses selanjutnya",
          "Masukkan “ PIN m-BCA ” untuk melanjutkan pembayaran",
          "Klik “ OK “ untuk menyelesaikan pembayaran",
          "Transaksi selesai dan Anda menerima notifikasi transaksi berhasil"
        ]
      }
    ]
  },
  {
    label: "Bank Permata",
    img: "https://cdn.siap.id/s3/masook/asset%20img/portal/pembayaran/bnli.png",
    pembayarans: [
      {
        label: "ATM (dalam Bahasa Indonesia)",
        deskripsi: [
          "Pilih jenis “ Transaksi Pembayaran ”",
          "Pilih jenis “ Pembayaran Telepon ”",
          "Masukkan “ 0 ” + 3 Digit Awal Kode Pembayaran ( Contoh: 021 menjadi “ 0021 ” )",
          "Masukkan “ 9 digit terakhir Kode Pembayaran ” yang Anda terima",
          "Pilih “ rekening sumber dana “ Anda dan pastikan sudah benar",
          "Pilih “ Ya “ untuk melanjutkan pembayaran",
          "Transaksi selesai dan Anda menerima struk transaksi berhasil"
        ]
      },
      {
        label: "Permata Mobile",
        deskripsi: [
          "Login akun Permata Mobile",
          "Pilih menu “ Pembayaran Tagihan “",
          "Pilih menu “ Telkom “",
          "Masukkan “ 12 digit kode pembayaran “ (021xxxxxxxxx) yang Anda diterima di kolom “ Kode Area + No. Telepon ”",
          "Muncul konfirmasi permintaan dan pastikan sudah benar",
          "Pilih menu “ Konfirmasi “ pada halaman permintaan serta untuk melanjutkan pembayaran",
          "Transaksi selesai dan Anda menerima notifikasi transaksi berhasil"
        ]
      }
    ]
  },
  {
    label: "Bank Danamon",
    img:
      "https://cdn.siap.id/s3/masook/asset%20img/portal/pembayaran/bank-danamon_20170128_172357.jpg",
    pembayarans: [
      {
        label: "ATM (dalam Bahasa Indonesia)",
        deskripsi: [
          "Pilih jenis “ Transaksi Pembayaran ”",
          "Pilih jenis “ Pembayaran Telepon ”",
          "Masukkan “ 0 ” + 3 Digit Awal Kode Pembayaran ( Contoh: 021 menjadi “ 0021 ” )",
          "Masukkan “ 9 digit terakhir Kode Pembayaran ” yang Anda terima",
          "Pilih “ rekening sumber dana “ Anda dan pastikan sudah benar",
          "Pilih “ Ya “ untuk melanjutkan pembayaran",
          "Transaksi selesai dan Anda menerima struk transaksi berhasil"
        ]
      },
      {
        label: "Danamon Mobile",
        deskripsi: [
          "Login ke dalam Danamon Mobile",
          "Pilih menu “ Pembayaran ”",
          "Pilih jenis Pembayaran “ Telco ”",
          "Klik “ Lanjut ”",
          "Pada “ Nomor Telepon ”, masukkan “ 12 digit kode pembayaran “ (021xxxxxxxxx) yang diterima di kolom “ Kode Area + No. Telepon ”",
          "Klik “ Bayar Sekarang ”",
          "Muncul konfirmasi permintaan dan pastikan sudah benar",
          "Masukkan “ PIN ” untuk konfirmasi dan proses selanjutnya",
          "Lalu klik “ OK ”, untuk melanjutkan pembayaran",
          "Transaksi selesai dan Anda menerima notifikasi transaksi berhasil"
        ]
      }
    ]
  },
  {
    label: "OCBC NISP",
    img:
      "https://cdn.siap.id/s3/masook/asset%20img/portal/pembayaran/042f80a2-eda8-4623-b75f-d3f5806b2c52_169.jpg",
    deskripsi: [
      "Pilih menu “ Lainnya ”",
      "Pilih menu “ Pembayaran “",
      "Pilih jenis pembayaran “ Telepon / Telkom ”",
      "Pilih jenis pembayaran “ Telepon / Internet “",
      "Masukkan “ 0 + 12 digit kode pembayaran “ (0021xxxxxxxxx) yang diterima di kolom “ Kode Area + No. Telepon ”",
      "Pilih “ Ya “ untuk melanjutkan pembayaran",
      "Muncul konfirmasi permintaan pembayaran pada layar ATM",
      "Setelah konfirmasi benar, pilih “ Bayar ” untuk melanjutkan pembayaran",
      "Transaksi selesai dan Anda menerima struk transaksi berhasil"
    ]
  },
  {
    label: "CIMB NIAGA",
    img:
      "https://cdn.siap.id/s3/masook/asset%20img/portal/pembayaran/Cimb%20Niaga.jpg",
    pembayarans: [
      {
        label: "ATM (dalam Bahasa Indonesia)",
        deskripsi: [
          "Pilih jenis “ Pembayaran ”",
          "Pilih jenis pembayaran “ Telepon / Seluler ”",
          "Masukkan “ 12 digit kode pembayaran “ (021xxxxxxxxx) yang diterima di kolom “ Kode Area + No. Telepon ”",
          "Pilih “ OK “ untuk melanjutkan proses selanjutnya",
          "Pilih “ rekening sumber dana “ Anda dan pastikan sudah benar",
          "Pilih “ OK “ untuk melanjutkan pembayaran",
          "Muncul konfirmasi permintaan dan pastikan sudah benar",
          "Pilih “ OK “ untuk melanjutkan pembayaran",
          "Transaksi selesai dan Anda menerima struk transaksi berhasil"
        ]
      },
      {
        label: "Internet Banking (CIMB Clicks)",
        deskripsi: [
          "Login akun CIMB Clicks",
          "Pilih menu “ Bayar Tagihan ”",
          "Pilih jenis pembayaran “ Telepon / Seluler “",
          "Pilih “ Pembayaran “ (Untuk memilih nama pembayaran & masukkan nomor rekening tagihan)",
          "Pilih jenis pembayaran “ Telkom Pay “",
          "Masukkan “ 12 digit kode pembayaran “ (021xxxxxxxxx) yang diterima di kolom “ Kode Area + No. Telepon ”",
          "Klik “ Lanjut “ untuk melanjutkan proses selanjutnya",
          "Muncul konfirmasi permintaan dan pastikan sudah benar",
          "Masukkan “ MPIN “ dan pilih “ Submit “ untuk melanjutkan pembayaran",
          "Transaksi selesai dan Anda menerima notifikasi transaksi berhasil"
        ]
      }
    ]
  },
  {
    label: "Bank SUMUT",
    img:
      "https://cdn.siap.id/s3/masook/asset%20img/portal/pembayaran/blog_asbanda_20191109023931.jpg",
    pembayarans: [
      {
        label: "ATM (dalam Bahasa Indonesia)",
        deskripsi: [
          'Pilih menu "Bayar / Beli“',
          'Pilih menu "Tagihan HP / Tagihan Telepon“',
          'Pilih menu "Telkom“',
          'Pilih menu "Jastel/flexy/telkompay/PSTN“',
          'Masukkan "12 digit kode bayar" (0211xxxxxx) yang diterima',
          'Pilih "Lanjutkan“',
          "Muncul konfirmasi permintaan dan pastikan sudah benar",
          'Pilih "Lanjutkan" untuk melanjutkan pembayaran',
          'Lalu pilih "Bayar“',
          "Transaksi Anda akan selesai dan Anda akanmenerima struk transaksi berhasil"
        ]
      },
      {
        label: "Mobile Banking (Bank Sumut New SMS Banking)",
        deskripsi: [
          "Masukkan “Username” dan “Password” Anda",
          'Pilih menu "Payment & Purchase“',
          'Pilih menu "Payment“',
          'Masukkan "Main source" akun Anda',
          'Pilih "Payment Category“',
          'Pilih "Utilities“',
          'Pilih Biller code "Speedy“',
          'Masukkan "12 digit kode bayar" (0211xxxxxx) yang diterima',
          'Lalu pilih "Bayar“',
          "Dan invoice akan muncul untuk menunjukkan transaksi pembayaran berhasil"
        ]
      }
    ]
  },
  {
    label: "Pegadaian dan POS Indonesia",
    img:
      "https://cdn.siap.id/s3/masook/asset%20img/portal/pembayaran/1200px-Pegadaian_logo_(2013).svg.png",
    subtitle: "Mendatangi kantor/cabang/agen terdekat",
    deskripsi: [
      "Pastikan Anda telah mendatkan kode pembayaran dan mencatat 12 digit kode pembayaran (021xxxxxxxxx)",
      "Anda mendatangi kantor/cabang/agen terdekat",
      "Anda memberitahukan petugas loket bahwa Anda inginmelakukan pembayaran tagihan “ Telkom ”",
      "Anda memberikan 12 digit kode pembayaran (021xxxxxxxxx)",
      "Petugas loket akan memproses permintaan Anda",
      "Petugasloket akan melakukan konfirmasi kepada Anda seperti nama dan nominal tagihan yang harus dibayar",
      "Apabila informasi sudah benar, Silakan Anda melakukan pembayaran",
      "Anda dapat melakukan pembayaran dengan uang tunai",
      "Transaksi selesai dan Anda menerima struk transaksi berhasil"
    ]
  }
];
